import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';
import './index.scss';

class PrintDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  // eslint-disable-next-line consistent-return
  createPages = (number) => {
    if (number) {
      const pages = [];
      for (let p = 1; p < number + 1; p += 1) {
        pages.push(<Page pageNumber={p} width={1000} key={`page--${p}`} />);
      }
      return pages;
    }
  }

  render() {
    const { doc } = this.props;
    const { numPages } = this.state;
    return(
      <Fragment>
        <style>
          {'@media print {#main-content{display: none;}}'}
        </style>
        <Document
          file={doc}
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          {this.createPages(numPages)}
        </Document>
      </Fragment>
    );
  }
}

PrintDoc.propTypes = {
  // The publicURL for a PDF file that you want the print version of the page to call upon
  doc: PropTypes.string
};


export default PrintDoc;
